import type { Template } from "@/types";

export const LA_04_H2_V2: Template[] = [
    {
        id: "la-04-h2v2-01",
        name: "LA 01 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 41, y: 113, width: 179, height: 257, rotation: 0, imageRotation: 0 },
            { id: "2", x: 228, y: 113, width: 404, height: 257, rotation: 0, imageRotation: 0 },
            { id: "3", x: 720, y: 113, width: 404, height: 257, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1132, y: 113, width: 179, height: 257, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-02",
        name: "LA 02 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 43, y: 105, width: 191, height: 274, rotation: 0, imageRotation: 0 },
            { id: "2", x: 241, y: 105, width: 432, height: 274, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 105, width: 431, height: 274, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1119, y: 105, width: 191, height: 274, rotation: 0, imageRotation: 0 }        
        ],
    },

    {
        id: "la-04-h2v2-03",
        name: "LA 03 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 95, width: 203, height: 293, rotation: 0, imageRotation: 0 },
            { id: "2", x: 210, y: 95, width: 462, height: 293, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 95, width: 461, height: 293, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1148, y: 95, width: 203, height: 293, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-04",
        name: "LA 04 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 43, y: 149, width: 291, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 149, width: 290, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 714, y: 33, width: 291, height: 417, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1013, y: 33, width: 290, height: 417, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-05",
        name: "LA 05 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 201, y: 47, width: 273, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 800, y: 47, width: 429, height: 207, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1092, y: 261, width: 138, height: 175, rotation: 0, imageRotation: 0 },
            { id: "4", x: 800, y: 261, width: 285, height: 175, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-06",
        name: "LA 06 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 174, y: 51, width: 306, height: 187, rotation: 0, imageRotation: 0 },
            { id: "2", x: 174, y: 245, width: 306, height: 187, rotation: 0, imageRotation: 0 },
            { id: "3", x: 743, y: 51, width: 268, height: 381, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 51, width: 268, height: 381, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-07",
        name: "LA 07 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 176, y: 45, width: 323, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 176, y: 237, width: 158, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 237, width: 158, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 743, y: 76, width: 543, height: 330, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-08",
        name: "LA 08 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 45, y: 60, width: 563, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 615, y: 60, width: 123, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 615, y: 244, width: 123, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 745, y: 60, width: 563, height: 362, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-09",
        name: "LA 09 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 40, y: 33, width: 289, height: 417, rotation: 0, imageRotation: 0 },
            { id: "2", x: 336, y: 121, width: 337, height: 241, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 121, width: 337, height: 241, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1024, y: 33, width: 289, height: 417, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-04-h2v2-10",
        name: "LA 10 - H2V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-04-h2_v2_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 82, y: 63, width: 140, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 82, y: 245, width: 140, height: 174, rotation: 0, imageRotation: 0 },
            { id: "3", x: 228, y: 63, width: 517, height: 356, rotation: 0, imageRotation: 0 },
            { id: "4", x: 752, y: 63, width: 517, height: 356, rotation: 0, imageRotation: 0 }
        ],
    }
];